import React from 'react';
import { Save, Trash2, Calendar, Clock } from 'lucide-react';
import Button from '../../../../../components/ui/Button';

const TemplatesSidebar = ({ 
  savedTemplates, 
  deleteTemplate, 
  loadTemplate 
}) => {
  // Если нет сохраненных шаблонов
  if (!savedTemplates || savedTemplates.length === 0) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
          <Save className="w-5 h-5 mr-2 text-indigo-500" />
          Сохраненные шаблоны
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Здесь будут отображаться сохраненные шаблоны расписаний для быстрого повторного использования.
        </p>
      </div>
    );
  }

  // Форматирование даты
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return new Intl.DateTimeFormat('ru-RU', { 
      day: 'numeric', 
      month: 'short',
      year: 'numeric'
    }).format(date);
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white flex items-center">
          <Save className="w-5 h-5 mr-2 text-indigo-500" />
          Сохраненные шаблоны
        </h3>
        <span className="text-sm text-gray-500 dark:text-gray-400">
          {savedTemplates.length} {savedTemplates.length === 1 ? 'шаблон' : savedTemplates.length < 5 ? 'шаблона' : 'шаблонов'}
        </span>
      </div>

      <div className="space-y-3 max-h-[400px] overflow-y-auto pr-1">
        {savedTemplates.map((template) => (
          <div 
            key={template.id} 
            className="bg-gray-50 dark:bg-gray-700/30 border border-gray-200 dark:border-gray-700 rounded-lg p-3 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors group relative"
          >
            <div className="flex justify-between items-start">
              <div>
                <h4 className="text-sm font-medium text-gray-900 dark:text-white">
                  {template.name}
                </h4>
                <div className="mt-1 text-xs text-gray-500 dark:text-gray-400 flex items-center">
                  <Calendar className="w-3 h-3 mr-1" />
                  <span>{formatDate(template.date)}</span>
                </div>
                <div className="mt-1 text-xs text-gray-500 dark:text-gray-400 flex items-center">
                  <Clock className="w-3 h-3 mr-1" />
                  <span>
                    {template.scheduleType === 'weekly' 
                      ? 'Недельное расписание' 
                      : template.scheduleType === 'monthly' 
                        ? 'Месячное расписание' 
                        : template.scheduleType === 'semester' 
                          ? 'Семестровое расписание' 
                          : 'Произвольный период'}
                  </span>
                </div>
              </div>
              <div className="flex items-center space-x-1">
                <button
                  type="button"
                  onClick={() => loadTemplate(template.id)}
                  className="p-1 text-gray-500 hover:text-indigo-600 dark:text-gray-400 dark:hover:text-indigo-400"
                  title="Загрузить шаблон"
                >
                  <Calendar className="w-4 h-4" />
                </button>
                <button
                  type="button"
                  onClick={() => deleteTemplate(template.id)}
                  className="p-1 text-gray-500 hover:text-red-600 dark:text-gray-400 dark:hover:text-red-400"
                  title="Удалить"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
            
            {/* Метрики шаблона */}
            <div className="mt-2 grid grid-cols-2 gap-2 text-xs">
              <div className="bg-white dark:bg-gray-800 rounded p-2 text-center">
                <div className="font-medium text-gray-800 dark:text-gray-200">
                  {template.formData.subjects.length}
                </div>
                <div className="text-gray-600 dark:text-gray-400">Предметов</div>
              </div>
              <div className="bg-white dark:bg-gray-800 rounded p-2 text-center">
                <div className="font-medium text-gray-800 dark:text-gray-200">
                  {template.formData.groups.length}
                </div>
                <div className="text-gray-600 dark:text-gray-400">Групп</div>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-4 border-t border-gray-200 dark:border-gray-700 pt-4">
        <Button
          type="button"
          icon={<Calendar className="w-4 h-4" />}
          variant="secondary"
          size="sm"
          fullWidth
          onClick={() => {
            const firstTemplate = savedTemplates[0];
            if (firstTemplate) {
              loadTemplate(firstTemplate.id);
            }
          }}
        >
          Загрузить последний шаблон
        </Button>
      </div>
    </div>
  );
};

export default TemplatesSidebar;